<template>
    <div
        class="absolute top-4 left-4 right-0 md:right-auto md:top-6 md:left-6 z-50"
    >
        <div
            v-if="mapType === 'search'"
            class="absolute top-12 left-0 right-4 lg:static lg:mb-4 lg:pr-40"
        >
            <transition name="fade">
                <SearchForm
                    v-show="showSearchForm"
                    :showCloseButton="true"
                    origin="map"
                    :showNearLabel="showNearLabel"
                    @closeForm="showSearchForm = false"
                />
            </transition>
        </div>
        <div class="flex items-center">
            <!-- open search form button (mobile) -->
            <button
                v-if="mapType !== 'property'"
                @click="showSearchForm = !showSearchForm"
                class="shadow dark:shadow-slate-900/50 font-medium text-sm rounded items-center flex h-9 px-3 py-1 text-slate-800 justify-start border border-slate-300 bg-white dark:bg-slate-800 whitespace-nowrap relative hover:bg-slate-200 active:border-slate-200 focus:outline-none focus:ring-inset focus:ring-slate-200 focus:ring-2 focus:border-slate-200 disabled:opacity-50 disabled:bg-white disabled:text-slate-800 mr-1 md:hidden"
            >
                <i class="far fa-search"></i>
            </button>
            <!-- end open search form button (mobile) -->
            <SearchFilterBar
                @handleSelect="handleSelect"
                v-if="mapType === 'search'"
            />
            <FavoritesFilters v-if="mapType === 'favorites'" />
        </div>
    </div>
</template>
<script setup>
import { ref } from 'vue';
import FavoritesFilters from '@/components/hotels/search/map-results/favorites-filters.vue';
import SearchFilterBar from '@/components/hotels/search/search-filter-bar/search-filter-bar.vue';
import SearchForm from '@/components/hotels/search/search-form/search-form.vue';

defineProps({
    mapType: String,
    showNearLabel: { type: Boolean, default: false },
});

const emit = defineEmits(['handleSelect']);
const showSearchForm = ref(false);
let viewportWidth = window.innerWidth;

const handleSelect = (data) => {
    emit('handleSelect', data);
};

if (viewportWidth < 768) {
    showSearchForm.value = false;
} else {
    showSearchForm.value = true;
}

window.addEventListener('resize', () => {
    viewportWidth = window.innerWidth;
    if (viewportWidth < 768) {
        showSearchForm.value = false;
    } else {
        showSearchForm.value = true;
    }
});
</script>
